import {isNil, memoize} from "lodash";
import moment from "moment";
import {useCallback, useEffect, useMemo, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import RaceComponent from "../components/basics/race/RaceComponent";
import {ParamTypes} from "../constans/paramTypes";
import {UnitTypes} from "../constans/unitTypes";
import {getRaces} from "../selectors/dictionarySelectors";
import {getAllGroups} from "../selectors/groupSelector";
import {getEmployeeList} from "../selectors/userSelector";
import {convertWeightUnitTo} from "../utils/UnitUtils";
import {createKeyToValueDictionary} from "../utils/Utils";

export function useSQLChartFormatters() {
    const {t} = useTranslation();

    const percentFormatterCache = useRef();
    const timeFormatterCache = useRef();
    const amountFormatterCache = useRef();

    useEffect(() => {
        return () => {
            if (percentFormatterCache.current)
                percentFormatterCache.current.cache.clear();
            if (timeFormatterCache.current)
                timeFormatterCache.current.cache.clear();
            if (amountFormatterCache.current)
                amountFormatterCache.current.cache.clear();
        };
    }, []);

    // const getBuildingsMap = useMemo(makeGetBuildingsMap, []);

    // const fallReasons = useSelector(getFallReasons);
    // const noPregnancyReasons = useSelector(getNoPregnancyReasons);
    // const buildingsMap = useSelector(getBuildingsMap);
    const races = useSelector(getRaces);
    const employees = useSelector(getEmployeeList);
    const allGroups = useSelector(getAllGroups);
    // const FarmID = useSelector(getFarmID);
    const allGroupsDictionary = useMemo(
        () => createKeyToValueDictionary(allGroups, "AnmGrp"),
        [allGroups]
    );

    // const animalFormatter = useCallback(
    //     (value) => {
    //         const animal =
    //             animalsDB.getAnimalById(value, {
    //                 joinEvents: false,
    //                 findDeleted: true,
    //             }) ||
    //             animalsDB.getAnimalByAnmNo1(value, FarmID, undefined, {
    //                 joinEvents: false,
    //                 findDeleted: true,
    //             });
    //         if (chartType === "Table") {
    //             return (
    //                 <AnimalReferenceDocumentModalGrid
    //                     object={animal}
    //                     key={value}
    //                 />
    //             );
    //         }
    //         if (!animal) return "";
    //         return formatAnimalName(animal);
    //     },
    //     [chartType, FarmID]
    // );

    const booleanFormatter = useCallback(
        (value) => {
            return value ? t("yes") : t("no");
        },
        [t]
    );

    // const parturitionLevelFormatter = useCallback(
    //     (value) => {
    //         switch (value) {
    //             case PARTURITION_DIFFICULTY.LOW:
    //                 return t("low");
    //             case PARTURITION_DIFFICULTY.MEDIUM:
    //                 return t("medium");
    //             case PARTURITION_DIFFICULTY.HARD:
    //                 return t("hard");
    //             default:
    //                 return "";
    //         }
    //     },
    //     [t]
    // );

    const makePercentFormatter = useMemo(() => {
        // ta linia aktualnie jest nie potrzebna, bo nie ma zadnych dependencji w useMemo, jak dodasz to odkomentuj tą linie
        // if (percentFormatterCache.current) percentFormatterCache.current.cache.clear();
        const memoized = memoize((precision) => {
            return (value) => {
                if (value === undefined || value === null) return null;
                return `${value.toFixed(precision)}%`;
            };
        });
        percentFormatterCache.current = memoized;
        return memoized;
    }, []);

    // const reasonFormatter = useCallback(
    //     (value) => {
    //         const row = fallReasons.WData.find((row) => row.ID === value);
    //         return row?.Value;
    //     },
    //     [fallReasons]
    // );

    // const noPregnancyReasonsFormatter = useCallback(
    //     (value) => {
    //         const row = noPregnancyReasons.WData.find(
    //             (row) => row.ID === value
    //         );
    //         return row?.Value;
    //     },
    //     [noPregnancyReasons]
    // );

    // const usgResultsFormatter = useCallback(
    //     (value) => {
    //         switch (value) {
    //             case false:
    //             case USG_STATE.NEGATIVE:
    //                 return t("events.usgEvent.negative");
    //             case true:
    //             case USG_STATE.POSITIVE:
    //                 return t("events.usgEvent.positive");
    //             case USG_STATE.REPEAT:
    //                 return t("events.usgEvent.toRepeat");
    //             default:
    //                 return "?";
    //         }
    //     },
    //     [t]
    // );

    // const sectorTypeFormatter = useCallback(
    //     (value) => {
    //         return t(`SType.${value - 1}`);
    //     },
    //     [t]
    // );

    const makeTimeFormatter = useMemo(() => {
        // ta linia aktualnie jest nie potrzebna, bo nie ma zadnych dependencji w useMemo, jak dodasz to odkomentuj tą linie
        // if (timeFormatterCache.current) timeFormatterCache.current.cache.clear();
        const memoized = memoize((dateFormat, useUTC) => {
            return (value) => {
                if (!value) return null;
                let tmp = value;
                if (!isNaN(+value)) tmp = +value;
                if (useUTC) return moment.utc(tmp).format(dateFormat);
                return moment(tmp).format(dateFormat);
            };
        });
        timeFormatterCache.current = memoized;
        return memoized;
    }, []);

    const weightFormatter = useCallback((value) => {
        return convertWeightUnitTo(value, {
            unit: UnitTypes.MEDIUM,
            rawValue: true,
            showUnit: false,
            fixed: 2,
        });
    }, []);

    const weekDayFormatter = useCallback((value) => {
        if (!value) return null;
        const date = moment().isoWeekday(value);
        return date.format("dd");
    }, []);

    // const locationFormatter = useCallback(
    //     (value) => {
    //         if (isNil(value)) return null;
    //         return formatLocationName(value, {buildingsMap});
    //     },
    //     [buildingsMap]
    // );

    // const dictionaryFormatter = useCallback(
    //     (value) => {
    //         if (!value) return null;
    //         const split = value.split("_");
    //         const type = split[0];
    //         const val = split.slice(1).join("_");
    //         switch (type) {
    //             case "FALL":
    //                 return reasonFormatter(val);
    //             case "NOPREGNANCY":
    //                 return noPregnancyReasonsFormatter(val);
    //             default:
    //                 return value;
    //         }
    //     },
    //     [reasonFormatter, noPregnancyReasonsFormatter]
    // );

    // const technologyGroupRemovalFormatter = useCallback(
    //     (value) => {
    //         if (value === null) return "";
    //         let res = removeReasonFormatter({reason: value}, false);
    //         if (res) return res;
    //         const split = (value + "").split("_");
    //         const reason = split.slice(1).join("_");
    //         return dictionaryFormatter(reason);
    //     },
    //     [dictionaryFormatter]
    // );

    // const removeAnimalReasonFormatter = useCallback((value) => {
    //     if (value === null) return "";
    //     return i18n.t(`sowStatus.${value}`);
    // }, []);

    const makeAmountFormatter = useMemo(() => {
        // ta linia aktualnie jest nie potrzebna, bo nie ma zadnych dependencji w useMemo, jak dodasz to odkomentuj tą linie
        // if (percentFormatterCache.current) percentFormatterCache.current.cache.clear();
        const memoized = memoize((precision) => {
            return (value) => {
                if (isNil(value) || typeof value !== "number") return null;
                return value.toFixed(precision);
            };
        });
        amountFormatterCache.current = memoized;
        return memoized;
    }, []);

    // const raceFormatter = useCallback(
    //     (value) => {
    //         if (!value) return t("none");
    //         const race = races.WData.find((item) => item.ID === value);
    //         if (!race) return t("notFound");
    //         return race.Value;
    //     },
    //     [races, t]
    // );

    const raceCodeFormatter = useCallback(
        (value) => {
            if (!value) return null;
            const race = races.WData.find((item) => item.ID === value);
            if (!race) return null;
            return <RaceComponent id={value} showOnlyCode />;
        },
        [races]
    );

    // const sowStatusFormatter = useCallback(
    //     (value) => {
    //         return t(`sowStatus.${value}`);
    //     },
    //     [t]
    // );

    const userFormatter = useCallback(
        (value) => {
            const user = employees.find((item) => item.LocalUserID === value);
            if (user) return `${user.firstname || ""} ${user.surname || ""}`;
            return value;
        },
        [employees]
    );

    const groupFormatter = useCallback(
        (value) => {
            const group = allGroupsDictionary[value];
            if (!group) return value;
            return group.GrNo1;
        },
        [allGroupsDictionary]
    );

    const monthFormatter = useCallback((value) => {
        if (isNil(value)) return null;
        const date = moment().month(value);
        return date.format("MMMM");
    }, []);

    // const animalKindFormatter = useCallback(
    //     (value) => {
    //         if (value === undefined) return null;
    //         return t(`animalKind.${value}`);
    //     },
    //     [t]
    // );

    const dictionaryFormatter = useCallback(
        (value) => {
            if (value) return value;
            return t("unknownReason");
        },
        [t]
    );

    const arrayFormatter = useCallback((value) => {
        if (!value) return null;
        if (Array.isArray(value)) return value.join(", ");
        return value;
    }, []);

    const makeArrayFormatter = useCallback((formatter) => {
        return function valueFormatter(value) {
            if (isNil(value)) return null;
            if (Array.isArray(value)) return value.map(formatter).join(", ");
            return formatter(value);
        };
    }, []);

    return useCallback(
        (type, {precision = 2, dateFormat = "L", useUTC = false} = {}) => {
            if (typeof type === "function") return type;
            switch (type) {
                // case ParamTypes.ANIMAL:
                //     return animalFormatter;
                case ParamTypes.BOOLEAN:
                    return makeArrayFormatter(booleanFormatter);
                // case ParamTypes.PARTURITION_LEVEL:
                // return parturitionLevelFormatter;
                case ParamTypes.PERCENT:
                    return makeArrayFormatter(makePercentFormatter(precision));
                // case ParamTypes.REASON:
                // return reasonFormatter;
                // case ParamTypes.RESULT:
                // return usgResultsFormatter;
                // case ParamTypes.SECTOR_TYPE:
                // return sectorTypeFormatter;
                // case ParamTypes.TECHNOLOGY_GROUP_REMOVAL:
                // return technologyGroupRemovalFormatter;
                // case ParamTypes.REMOVED_REASONS:
                // return removeAnimalReasonFormatter;
                case ParamTypes.DATE:
                case ParamTypes.TIME:
                    return makeArrayFormatter(
                        makeTimeFormatter(dateFormat, useUTC)
                    );
                case ParamTypes.WEIGHT:
                    return makeArrayFormatter(weightFormatter);
                case ParamTypes.WEEK_DAY:
                    return makeArrayFormatter(weekDayFormatter);
                // case ParamTypes.LOCATION:
                // return locationFormatter;
                // case ParamTypes.DICTIONARY:
                // return dictionaryFormatter;
                // case ParamTypes.AMOUNT:
                //     return amountFormatter(precision);
                // case ParamTypes.RACE:
                // return raceFormatter;
                // case ParamTypes.SOW_STATE:
                // return sowStatusFormatter;
                case ParamTypes.USER:
                    return makeArrayFormatter(userFormatter);
                case ParamTypes.RACE_CODE:
                    return makeArrayFormatter(raceCodeFormatter);
                case ParamTypes.GROUP_NR:
                    return makeArrayFormatter(groupFormatter);
                case ParamTypes.MONTH:
                    return makeArrayFormatter(monthFormatter);
                case ParamTypes.TATTOO:
                case ParamTypes.RFID:
                case ParamTypes.HERD_NUMBER:
                case ParamTypes.ANIMAL:
                case ParamTypes.PARTURITION_LEVEL:
                case ParamTypes.REASON:
                case ParamTypes.RESULT:
                case ParamTypes.SECTOR_TYPE:
                case ParamTypes.TECHNOLOGY_GROUP_REMOVAL:
                case ParamTypes.REMOVED_REASONS:
                case ParamTypes.LOCATION:
                case ParamTypes.RACE:
                case ParamTypes.SOW_STATE:
                case ParamTypes.ANIMAL_KIND:
                case ParamTypes.SELL_REASON:
                case ParamTypes.SELECTION_REASON:
                    return arrayFormatter;
                case ParamTypes.DICTIONARY:
                    return makeArrayFormatter(dictionaryFormatter);
                // case ParamTypes.ANIMAL_KIND:
                //     return animalKindFormatter;
                default:
                    return makeArrayFormatter(makeAmountFormatter(precision));
            }
        },
        [
            // animalFormatter,
            booleanFormatter,
            // parturitionLevelFormatter,
            makePercentFormatter,
            // reasonFormatter,
            // usgResultsFormatter,
            // sectorTypeFormatter,
            // technologyGroupRemovalFormatter,
            makeTimeFormatter,
            weightFormatter,
            weekDayFormatter,
            // locationFormatter,
            dictionaryFormatter,
            makeAmountFormatter,
            // raceFormatter,
            // sowStatusFormatter,
            userFormatter,
            raceCodeFormatter,
            groupFormatter,
            monthFormatter,
            // animalKindFormatter,
            // removeAnimalReasonFormatter,
            makeArrayFormatter,
            arrayFormatter,
        ]
    );
}
